import React, { useState } from "react";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import logo from "../assets/images/logo.jpeg";
// <-- your CarFinders SA logo

export default function CarFinanceCalculator() {
  const [amount, setAmount] = useState("");
  const [depositPercent, setDepositPercent] = useState("");
  const [balloonPercent, setBalloonPercent] = useState("");
  const [years, setYears] = useState("");
  const [interestRate, setInterestRate] = useState("");
  const [schedule, setSchedule] = useState([]);

  const calculatePayment = () => {
    const loanAmount = parseFloat(amount);
    const deposit = (parseFloat(depositPercent) / 100) * loanAmount;
    const balloon = (parseFloat(balloonPercent) / 100) * loanAmount;

    const financedAmount = loanAmount - deposit - balloon;
    const annualRate = parseFloat(interestRate) / 100;
    const monthlyRate = annualRate / 12;
    const months = parseInt(years) * 12;

    if (isNaN(financedAmount) || isNaN(monthlyRate) || isNaN(months)) {
      setSchedule([]);
      return;
    }

    const payment =
      (financedAmount * monthlyRate * Math.pow(1 + monthlyRate, months)) /
      (Math.pow(1 + monthlyRate, months) - 1);

    let balance = financedAmount;
    const newSchedule = [];

    for (let m = 1; m <= months; m++) {
      const interest = balance * monthlyRate;
      const principal = payment - interest;
      balance -= principal;

      newSchedule.push({
        month: m,
        payment: payment.toFixed(2),
        principal: principal.toFixed(2),
        interest: interest.toFixed(2),
        balance: balance.toFixed(2),
      });
    }

    if (balloon > 0) {
      newSchedule[months - 1].payment = (
        parseFloat(newSchedule[months - 1].payment) + balloon
      ).toFixed(2);
      newSchedule[months - 1].balance = "0.00";
    }

    setSchedule(newSchedule);
  };

  const exportPDF = () => {
    const doc = new jsPDF();

    // Logo
    doc.addImage(logo, "JPEG", 14, 10, 30, 15);

    // Title
    doc.setFontSize(16);
    doc.setTextColor(44, 44, 44);
    doc.text("CarFinders SA - Repayment Schedule", 50, 20);

    const tableData = schedule.map((row) => [
      row.month,
      row.payment,
      row.principal,
      row.interest,
      row.balance,
    ]);

    // ✅ Correct usage
    autoTable(doc, {
      head: [
        [
          "Month",
          "Payment (R)",
          "Principal (R)",
          "Interest (R)",
          "Balance (R)",
        ],
      ],
      body: tableData,
      startY: 35,
      styles: { fontSize: 9 },
      headStyles: {
        fillColor: [212, 175, 55],
        textColor: [0, 0, 0],
        halign: "center",
      },
      bodyStyles: { halign: "center" },
    });

    doc.save("CarFindersSA_RepaymentSchedule.pdf");
  };

  return (
    <section id="calculator">
      <div
        className="car-finance-calculator"
        style={{ maxWidth: "600px", margin: "40px auto", fontFamily: "Arial" }}
      >
        <h2>Car Finance Calculator</h2>
        <input
          type="number"
          placeholder="Vehicle Price (R)"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
        />
        <input
          type="number"
          placeholder="Deposit (%)"
          value={depositPercent}
          onChange={(e) => setDepositPercent(e.target.value)}
        />
        <input
          type="number"
          placeholder="Balloon (%)"
          value={balloonPercent}
          onChange={(e) => setBalloonPercent(e.target.value)}
        />
        <input
          type="number"
          placeholder="Loan Term (years)"
          value={years}
          onChange={(e) => setYears(e.target.value)}
        />
        <input
          type="number"
          placeholder="Interest Rate (%)"
          value={interestRate}
          onChange={(e) => setInterestRate(e.target.value)}
        />
        <button onClick={calculatePayment} style={{ marginTop: "15px" }}>
          Calculate
        </button>

        {schedule.length > 0 && (
          <>
            <table
              style={{
                marginTop: "20px",
                width: "100%",
                borderCollapse: "collapse",
                fontSize: "0.9rem",
              }}
            >
              <thead>
                <tr style={{ background: "#333", color: "#fff" }}>
                  <th>Month</th>
                  <th>Payment (R)</th>
                  <th>Principal (R)</th>
                  <th>Interest (R)</th>
                  <th>Balance (R)</th>
                </tr>
              </thead>
              <tbody>
                {schedule.map((row) => (
                  <tr key={row.month}>
                    <td>{row.month}</td>
                    <td>{row.payment}</td>
                    <td>{row.principal}</td>
                    <td>{row.interest}</td>
                    <td>{row.balance}</td>
                  </tr>
                ))}
              </tbody>
            </table>

            <button onClick={exportPDF} style={{ marginTop: "20px" }}>
              Download PDF
            </button>
          </>
        )}
      </div>
    </section>
  );
}
